import type { Attitude } from "@/types/content";

interface AttitudeBarProps {
  attitude: Attitude;
  showLegend?: boolean;
  size?: "sm" | "md";
}

const segments = [
  { key: "support" as const, label: "支持", bar: "bg-secondary-500" },
  { key: "neutral" as const, label: "中立", bar: "bg-background-400" },
  { key: "oppose" as const, label: "反对", bar: "bg-primary-500" },
];

export default function AttitudeBar({
  attitude,
  showLegend = true,
  size = "md",
}: AttitudeBarProps) {
  const height = size === "sm" ? "h-2" : "h-3";
  return (
    <div>
      <div className={`flex w-full overflow-hidden rounded-full ${height}`} role="img" aria-label={`舆论态度分布：支持 ${attitude.support}%，中立 ${attitude.neutral}%，反对 ${attitude.oppose}%`}>
        {segments.map((seg) => (
          <span
            key={seg.key}
            className={seg.bar}
            style={{ width: `${attitude[seg.key]}%` }}
          />
        ))}
      </div>
      {showLegend && (
        <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs">
          {segments.map((seg) => (
            <span key={seg.key} className="inline-flex items-center gap-2 text-foreground-600">
              <span className={`h-2.5 w-2.5 rounded-sm ${seg.bar}`} aria-hidden="true" />
              {seg.label}
              <span className="font-medium text-foreground-900">
                {attitude[seg.key]}%
              </span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}